@if (errorMessage(); as msg) {
  <div class="d-flex gap-3 align-items-center mt-2 alert alert-danger">
    <i class="fas fa-times-circle"></i>
    <span [id]="errorKey">{{msg}}</span>
  </div>
}
